export default __webpack_public_path__ + "static/media/Elec11.574eaf65.png";